import { navigationRoutingRegistry } from "../navigationRouting";
import type { NavigationRoutingObject } from "../types";

/**
 * Returns the navigation routing object for the given pathname
 * @param pathname The pathname to get the navigation routing object for
 * @returns The navigation routing object
 */
export const getNavigationRoutingObject = (
  pathname: keyof typeof navigationRoutingRegistry
): NavigationRoutingObject | undefined => {
  return navigationRoutingRegistry[pathname];
};
